export default __webpack_public_path__ + "static/B0272-ae2044714690d37388f1530cae2be415.png";